var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-pencil",
  "use": "ring-icon-pencil-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-pencil\"><path d=\"M15.619 3.485L12.524.39a1.406 1.406 0 0 0-1.943 0L1.436 9.535a1.428 1.428 0 0 0-.381.684L.026 14.625a.968.968 0 0 0 .94 1.19.993.993 0 0 0 .177-.016l4.52-.831a1.663 1.663 0 0 0 .876-.46l9.08-9.08a1.375 1.375 0 0 0 0-1.943zM6.474 12.45L3.557 9.534l6.549-6.548 2.917 2.916zm-3.508 1.487L1.957 12.93l.54-2.334 2.896 2.896-.003.001z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id